import { Beneficiario } from "./afiliaciones/beneficiario.model";
import { ConyugeModel } from "./afiliaciones/conyuge.model";
import { Empresa } from "./afiliaciones/empresa.model";
import { Titular } from "./afiliaciones/titular.model";
import { Solicitud } from "./solicitud.model";

export class SolicitudContratoModel {
  public version: string = "1.0";
  public empresa: Empresa;
  public titular: Titular;
  public conyuge: ConyugeModel;
  public beneficiarios: Beneficiario[] = [];
  public solicitud: Solicitud;

  public esSolicitudConBeneficiarios() {
    return this.beneficiarios.length > 0;
  }

  public hayBeneficiariosSinComplementos() {
    return this.beneficiarios.some(ben => !ben.esContratoConComplementos());
  }
}